export default __webpack_public_path__ + "static/media/sh_6.b29e0e2e.png";